<template>
    <div>
        <draggable :list="section.tasks" draggable=".draggable" handle=".handle" @change="tasksReordered" :disabled="estimate.cannot_be_edited_by_authed_user">
            <estimates-old-page-task v-for="task in section.tasks" :key="task.key" :task="task" :section="section" ref="tasks"></estimates-old-page-task>
        </draggable>

        <!-- New Task. -->
        <div class="flex items-center mt-10 mb-1" v-if="! estimate.cannot_be_edited_by_authed_user">
            <div class="w-6 flex-shrink-0">
                <i class="fa fa-plus text-sm text-gray-400"></i>
            </div>
            <div class="w-12">
                <input
                    :placeholder="nextTaskReference"
                    class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    type="text"
                    v-model="newTask.reference"
                >
            </div>
            <div class="flex-1 ml-4">
                <input
                    placeholder="Add a new task..."
                    class="text-sm m-0 px-2 py-1 font-bold text-gray-900 border-transparent rounded shadow-none relative focus:z-10"
                    type="text"
                    v-model="newTask.name"
                    @input="addTask"
                >
            </div>
            <div class="w-6 flex-shrink-0 ml-2"></div>
        </div>
    </div>
</template>

<script>
import { estimateStore } from '@stores'
import draggable from 'vuedraggable'

export default {
    components: {
        draggable,
    },
    props: {
        section: Object,
    },
    data () {
        return {
            newTask: {
                reference: null,
                name: null,
            },
        }
    },
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return this.$store.state.estimate
        },
        nextTaskReference () {
            const sectionNumber = this.estimate.sections.indexOf(this.section) + 1
            const taskNumber = this.section.tasks.length + 1
            return `${sectionNumber}.${taskNumber}`
        },
    },
    methods: {
        tasksReordered () {
            this.$store.repopulateNumbers()
            this.$store.save()
        },
        addTask () {
            if (! this.newTask.name) return
            this.$store.addTask(this.section, this.newTask.name, this.newTask.reference)

            this.$nextTick(() => {
                this.$refs.tasks[this.$refs.tasks.length - 1].$refs.name.focus()
                this.newTask.reference = ''
                this.newTask.name = ''
            })
        },
    },
}
</script>
